import { z } from 'zod';
import { MEAL_TYPE_VALUES } from '../constants.js';
export const mealItemInputSchema = z
    .object({
    foodId: z.string().uuid().optional(),
    recipeId: z.string().uuid().optional(),
    quantity: z.number().positive(),
    unit: z.string().min(1).max(20),
    /** Set when this item came from AI photo recognition — the AI's own identification confidence (0-1). */
    aiConfidence: z.number().min(0).max(1).optional(),
})
    .refine((data) => Boolean(data.foodId) !== Boolean(data.recipeId), {
    message: 'Provide exactly one of foodId or recipeId',
    path: ['foodId'],
});
export const createMealSchema = z.object({
    mealType: z.enum(MEAL_TYPE_VALUES),
    loggedAt: z.string().datetime(),
    notes: z.string().max(1000).optional(),
    photoR2Key: z.string().max(500).optional(),
    clientId: z.string().uuid().optional(),
    items: z.array(mealItemInputSchema).min(1, 'A meal needs at least one item'),
});
export const updateMealSchema = z.object({
    mealType: z.enum(MEAL_TYPE_VALUES).optional(),
    loggedAt: z.string().datetime().optional(),
    notes: z.string().max(1000).optional(),
    items: z.array(mealItemInputSchema).min(1).optional(),
});
export const listMealsQuerySchema = z.object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
